var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220.6,
    height: 220.6,
    viewBox: "0 0 220.6 220.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M110.3,124.087A62.044,62.044,0,1,0,48.256,62.044,62.06,62.06,0,0,0,110.3,124.087Zm55.15,13.787h-23.74a75,75,0,0,1-62.819,0H55.15A55.146,55.146,0,0,0,0,193.025v6.894A20.687,20.687,0,0,0,20.681,220.6H199.918A20.687,20.687,0,0,0,220.6,199.918v-6.894A55.146,55.146,0,0,0,165.45,137.875Z",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.6c568700dfb03e04ed500de4a7e74efa.svg";
export { ForwardRef as ReactComponent };